import {Button} from "@mui/material";
import * as React from 'react';
import PhoneNumberCommonComponent from "./PhoneNumberCommonComponent";
import {useTranslation} from "i18nano";

interface PhoneNumberAuthenticatorComponentProps {
    onClick: (phoneNumber: string) => void,
    onClickSkip: () => void,
    loading: boolean,
    errors: string[]
}

const PhoneNumberAuthenticatorComponent: React.FC<PhoneNumberAuthenticatorComponentProps> =
    ({
         onClick,
         loading,
         onClickSkip,
         errors
     }) => {
        const t = useTranslation();
        return (
            <>
                <PhoneNumberCommonComponent onClick={onClick} loading={loading} errors={errors}/>
                <Button style={{marginTop: 10}} variant="outlined" size={"large"} onClick={onClickSkip}
                        fullWidth>{t("Skip")}</Button>
            </>
        )

    }
export default PhoneNumberAuthenticatorComponent